import { render } from "./New_FlagUnflagForm.vue?vue&type=template&id=85e8bfda&scoped=true"
import script from "./New_FlagUnflagForm.vue?vue&type=script&lang=js"
export * from "./New_FlagUnflagForm.vue?vue&type=script&lang=js"

import "./New_FlagUnflagForm.vue?vue&type=style&index=0&id=85e8bfda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e8bfda"]])

export default __exports__